export function duplicateCarouselLogos() {
  function duplicateLogos(numberOfDuplicates) {
    const carousel = document.querySelector(".logos .marquee__inner");
    if (carousel) {
      const logos = carousel.innerHTML;
      for (let i = 0; i < numberOfDuplicates; i++) {
        carousel.innerHTML += logos;
      }
    }
  }
  duplicateLogos(10);

  function duplicateText(numberOfDuplicates) {
    const carousel = document.querySelector(".text-marquee__inner");
    if (carousel) {
      const logos = carousel.innerHTML;
      for (let i = 0; i < numberOfDuplicates; i++) {
        carousel.innerHTML += logos;
      }
    }
  }
  duplicateText(10);
}
